import * as arAE from "./translations/adsstatus-ar-AE.puff.json";
import * as deDE from './translations/adsstatus-de-DE.puff.json';
import * as enAU from './translations/adsstatus-en-AU.puff.json';
import * as enCA from './translations/adsstatus-en-CA.puff.json';
import * as enGB from './translations/adsstatus-en-GB.puff.json';
import * as enIN from './translations/adsstatus-en-IN.puff.json';
import * as enSG from './translations/adsstatus-en-SG.puff.json';
import * as enUS from './translations/adsstatus-en-US.puff.json';
import * as esCO from './translations/adsstatus-es-CO.puff.json';
import * as esMX from './translations/adsstatus-es-MX.puff.json';
import * as esES from './translations/adsstatus-es-ES.puff.json';
import * as frCA from './translations/adsstatus-fr-CA.puff.json';
import * as frFR from './translations/adsstatus-fr-FR.puff.json';
import * as hiIN from './translations/adsstatus-hi-IN.puff.json';
import * as itIT from './translations/adsstatus-it-IT.puff.json';
import * as jaJP from './translations/adsstatus-ja-JP.puff.json';
import * as koKR from './translations/adsstatus-ko-KR.puff.json';
import * as nlNL from './translations/adsstatus-nl-NL.puff.json';
import * as plPL from './translations/adsstatus-pl-PL.puff.json';
import * as ptBR from './translations/adsstatus-pt-BR.puff.json';
import * as svSE from './translations/adsstatus-sv-SE.puff.json';
import * as taIN from './translations/adsstatus-ta-IN.puff.json';
import * as thTH from './translations/adsstatus-th-TH.puff.json';
import * as trTR from './translations/adsstatus-tr-TR.puff.json';
import * as viVN from './translations/adsstatus-vi-VN.puff.json';
import * as zhCN from './translations/adsstatus-zh-CN.puff.json';
import * as zhTW from './translations/adsstatus-zh-TW.puff.json';

const localeToPuffFile = {
    "ar-AE": arAE,
    "de-DE": deDE,
    "en-AU": enAU,
    "en-CA": enCA,
    "en-GB": enGB,
    "en-IN": enIN,
    "en-SG": enSG,
    "en-US": enUS,
    "es-MX": esMX,
    "es-ES": esES,
    "fr-CA": frCA,
    "fr-FR": frFR,
    "hi-IN": hiIN,
    "es-CO": esCO,
    "it-IT": itIT,
    "ja-JP": jaJP,
    "ko-KR": koKR,
    "nl-NL": nlNL,
    "pl-PL": plPL,
    "pt-BR": ptBR,
    "sv-SE": svSE,
    "ta-IN": taIN,
    "th-TH": thTH,
    "vi-VN": viVN,
    "tr-TR": trTR,
    "zh-CN": zhCN,
    "zh-TW": zhTW,
};

type PuffFile = {
    [locale: string]: {
        resources: {
            [key: string]: {
                value: string;
                note?: string;
            };
        };
    };
};

export const translationsByLanguageCode = (
    locale: string,
    localeMap: PuffFile = localeToPuffFile
): { [key: string]: string } => {
    const messages =
        locale in localeMap
            ? localeMap[locale].resources
            : localeMap["en-US"].resources;

    if (!messages) {
        return {};
    }

    return Object.keys(messages).reduce((acc: { [key: string]: string }, curr) => {
        const value = messages[curr]?.value;
        if (value) {
            acc[curr] = value;
        }
        return acc;
    }, {});
};
